// From where follow / unfollow operation can be called
export const FollowOperationLocation = {
  USER_PROFILE: 'user_profile',
  STORY_HEADER: 'story_header',
  STORY_FOOTER: 'story_footer',
  SERIES_DETAIL: 'series_detail',
  FOLLOW_LIST: 'follow_list',
  FOLLOWER_LIST: 'follower_list',
  SEARCH_USER_LIST: 'search_user_list',
  USERS: 'users',
  NOTIFICATION_LIST: 'notification_list',
  NOTIFICATION_MENU: 'notification_menu',
  CONTEST_AWARD: 'contest_award',
} as const;
export type FollowOperationLocation =
  typeof FollowOperationLocation[keyof typeof FollowOperationLocation];

export const FollowListModalType = {
  FOLLOWERS: 'followers',
  FOLLOWINGS: 'followings',
} as const;
export type FollowListModalType =
  typeof FollowListModalType[keyof typeof FollowListModalType];
